import React from 'react';
export var DragInMotionIcon = function DragInMotionIcon(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/React.createElement("svg", {
    width: "28",
    height: "20",
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: style
  }, /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "1",
    width: "26",
    height: "18",
    rx: "5",
    fill: "var(--ds-background-accent-blue-subtle, #579DFF)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "9",
    y: "6",
    width: "2",
    height: "8",
    rx: "1",
    fill: "var(--ds-border-inverse, #FFFFFF)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "13",
    y: "6",
    width: "2",
    height: "8",
    rx: "1",
    fill: "var(--ds-border-inverse, #FFFFFF)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "17",
    y: "6",
    width: "2",
    height: "8",
    rx: "1",
    fill: "var(--ds-border-inverse, #FFFFFF)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "1",
    width: "26",
    height: "18",
    rx: "5",
    stroke: "var(--ds-border-inverse, #FFFFFF)",
    strokeWidth: "2"
  }));
};